<dx-popup
    [title]="request?.type | capitalCase"
    [(visible)]="visible"
    [fullScreen]="!!(screen.xSmallScreenChanged | async)"
    [width]="'80%'"
    [height]="'90%'"
    (onHidden)="onClose()"
    [wrapperAttr]="{'class':'form-popup'}"
    [animation]="{ show: { type: 'fadeIn', duration: 200 }, hide: { type: 'fadeOut', duration: 200 } }"
    [showCloseButton]="true"
>
    <dx-validation-group #validationGroup class="d-flex flex-column h-100">
        @if (formData) {
            <div class="row flex-shrink-0">
                <div class="col-sm-6 mb-3">
                    <dx-tag-box
                        label="To"
                        placeholder="Add Roles, Users or Emails"
                        [acceptCustomValue]="true"
                        [(value)]="formData.to"
                        [items]="recipientOptions"
                        [searchEnabled]="true"
                        [showClearButton]="true"
                        stylingMode="filled"
                    >
                    </dx-tag-box>
                </div>
                <div class="col-sm-6 mb-3">
                    <dx-tag-box
                        label="Cc"
                        placeholder="Add Roles, Users or Emails"
                        [acceptCustomValue]="true"
                        [(value)]="formData.cc"
                        [searchEnabled]="true"
                        [items]="recipientOptions"
                        [showClearButton]="true"
                        stylingMode="filled"
                    >
                    </dx-tag-box>
                </div>
                <div class="col-12 mb-3">
                    <dx-text-box
                        label="Subject"
                        [(value)]="formData.subject"
                        stylingMode="filled"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Subject is required"></dxi-validation-rule>
                            <dxi-validation-rule type="stringLength" [max]="300" message="Subject must be less than 300 characters"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
            <div class="d-flex flex-column flex-grow-1 pb-2" style="min-height: 0;">
                <label class="form-label">Body</label>
                <dx-html-editor
                    [(value)]="formData.body"
                    [height]="'100%'"
                    stylingMode="filled"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Body is required"></dxi-validation-rule>
                    </dx-validator>
                    <dxo-html-editor-toolbar [multiline]="true">
                        <dxi-html-editor-item name="undo"></dxi-html-editor-item>
                        <dxi-html-editor-item name="redo"></dxi-html-editor-item>
                        <dxi-html-editor-item name="separator"></dxi-html-editor-item>
                        <dxi-html-editor-item
                            name="size"
                            [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"
                            [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
                        ></dxi-html-editor-item>
                        <dxi-html-editor-item
                            name="font"
                            [acceptedValues]="[
                                'Arial',
                                'Courier New',
                                'Georgia',
                                'Impact',
                                'Lucida Console',
                                'Tahoma',
                                'Times New Roman',
                                'Verdana'
                              ]"
                            [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
                        ></dxi-html-editor-item>
                        <dxi-html-editor-item name="separator"></dxi-html-editor-item>
                        <dxi-html-editor-item name="bold"></dxi-html-editor-item>
                        <dxi-html-editor-item name="italic"></dxi-html-editor-item>
                        <dxi-html-editor-item name="strike"></dxi-html-editor-item>
                        <dxi-html-editor-item name="underline"></dxi-html-editor-item>
                        <dxi-html-editor-item name="separator"></dxi-html-editor-item>
                        <dxi-html-editor-item name="alignLeft"></dxi-html-editor-item>
                        <dxi-html-editor-item name="alignCenter"></dxi-html-editor-item>
                        <dxi-html-editor-item name="alignRight"></dxi-html-editor-item>
                        <dxi-html-editor-item name="alignJustify"></dxi-html-editor-item>
                        <dxi-html-editor-item name="separator"></dxi-html-editor-item>
                        <dxi-html-editor-item name="orderedList"></dxi-html-editor-item>
                        <dxi-html-editor-item name="bulletList"></dxi-html-editor-item>
                        <dxi-html-editor-item name="separator"></dxi-html-editor-item>
                        <dxi-html-editor-item
                            name="header"
                            [acceptedValues]="[false, 1, 2, 3, 4, 5]"
                            [options]="{ inputAttr: { 'aria-label': 'Header' } }"
                        ></dxi-html-editor-item>
                        <dxi-html-editor-item name="separator"></dxi-html-editor-item>
                        <dxi-html-editor-item name="color"></dxi-html-editor-item>
                        <dxi-html-editor-item name="background"></dxi-html-editor-item>
                        <dxi-html-editor-item name="separator"></dxi-html-editor-item>
                        <dxi-html-editor-item name="link"></dxi-html-editor-item>
                        <dxi-html-editor-item name="image"></dxi-html-editor-item>
                        <dxi-html-editor-item name="separator"></dxi-html-editor-item>
                        <dxi-html-editor-item name="clear"></dxi-html-editor-item>
                        <dxi-html-editor-item name="codeBlock"></dxi-html-editor-item>
                        <dxi-html-editor-item name="blockquote"></dxi-html-editor-item>
                        <dxi-html-editor-item name="separator"></dxi-html-editor-item>
                        <dxi-html-editor-item name="insertTable"></dxi-html-editor-item>
                        <dxi-html-editor-item name="deleteTable"></dxi-html-editor-item>
                        <dxi-html-editor-item name="insertRowAbove"></dxi-html-editor-item>
                        <dxi-html-editor-item name="insertRowBelow"></dxi-html-editor-item>
                        <dxi-html-editor-item name="deleteRow"></dxi-html-editor-item>
                        <dxi-html-editor-item name="insertColumnLeft"></dxi-html-editor-item>
                        <dxi-html-editor-item name="insertColumnRight"></dxi-html-editor-item>
                        <dxi-html-editor-item name="deleteColumn"></dxi-html-editor-item>
                    </dxo-html-editor-toolbar>
                    <dxo-html-editor-media-resizing [enabled]="true">
                    </dxo-html-editor-media-resizing>
                </dx-html-editor>
            </div>
        }
    </dx-validation-group>

    <dxi-popup-toolbar-item toolbar="bottom" location="center">
        <div class="d-flex align-items-center justify-content-end gap-3">
            <dx-button
                text="Submit"
                stylingMode="contained"
                type="default"
                (onClick)="onSave()"
            ></dx-button>
            <dx-button
                text="Cancel"
                stylingMode="contained"
                type="normal"
                (onClick)="onClose()"
            ></dx-button>
        </div>
    </dxi-popup-toolbar-item>
</dx-popup>
